module.exports = __webpack_public_path__ + "img/8.9f8b3c67.png";